module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.c90f6c0b.svg";